
import AIWaitingScreen from "../../components/AIWaiting";

function AIWaiting() {
  return <AIWaitingScreen />;
}

export default AIWaiting;
